import { useMemo, useState } from "react";
import ArticleCard from "@/components/base/ArticleCard";
import { articles, channels } from "@/mocks/gossip";

const tabs = [{ slug: "all", name: "全部" }, ...channels.map((c) => ({ slug: c.slug, name: c.name }))];

export default function LatestSection() {
  const [active, setActive] = useState("all");

  const list = useMemo(() => {
    const filtered = active === "all" ? articles : articles.filter((a) => a.channelSlug === active);
    return filtered.slice(0, 6);
  }, [active]);

  return (
    <section id="latest" className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-8">
          <div>
            <span className="inline-flex items-center gap-2 text-xs md:text-sm text-primary-600 font-medium">
              <i className="ri-flashlight-line" />
              最新爆料
            </span>
            <h2 className="mt-2.5 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
              持续更新的瓜料动态
            </h2>
          </div>
        </div>

        <div className="flex items-center gap-2 overflow-x-auto pb-1 mb-8">
          {tabs.map((tab) => (
            <button
              key={tab.slug}
              type="button"
              onClick={() => setActive(tab.slug)}
              className={`shrink-0 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                active === tab.slug
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-50 text-foreground-700 border border-background-300 hover:border-primary-300 hover:text-primary-600"
              }`}
            >
              {tab.name}
            </button>
          ))}
        </div>

        {list.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {list.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        ) : (
          <p className="py-14 text-center text-sm text-foreground-500">该频道暂时还没有整理好的爆料，换个方向看看。</p>
        )}
      </div>
    </section>
  );
}